import Base from "@/models/Base"
import type { IUserNextOfKinDetail } from "@/interfaces/users/IUserNextOfKinDetail"

class NextOfKinDetail extends Base implements IUserNextOfKinDetail {
  name: string
  emailAddress: string
  relationship: string
  phoneNumber: string
  alternatePhoneNumber: string

  constructor(nextOfKinDetail: any) {
    super(nextOfKinDetail)
    this.name = nextOfKinDetail?.name ?? null
    this.emailAddress = nextOfKinDetail?.emailAddress ?? null
    this.relationship = nextOfKinDetail?.relationship ?? null
    this.phoneNumber = nextOfKinDetail?.phoneNumber ?? null
    this.alternatePhoneNumber = nextOfKinDetail?.alternatePhoneNumber ?? null
  }
}

export default NextOfKinDetail
